import i18n from 'l10n';
import _ from 'underscore';
import GenericView from 'js/views/generic.view';
import PaginatedView from 'js/views/pagination.view';
import Template from 'js/templates/service.report.contents.hbs';
import Optional from 'optional-js';
import {el, once, tagName, template} from "../adapters/backbone-decorators";

require('jqueryUI');
require('metroHelpers');

@el(".service_report_content")
@tagName('div')
@template(Template)
class VoucherReportContentsView extends GenericView {
    service = "";

    constructor(options) {
        super(options);
        this.serviceCollection = options.serviceCollection;
        this.serviceType = options.serviceType;
        this.questions = options.questions;
        this.isSweepstakes = options.isSweepstakes;
        this.description = options.description;
        this.setupCustomFields().then(() => {
            //on collection "sync", update template values (service detailed report)
            this.serviceCollection.on('sync', () => this.syncHandler());
            this.loadContent();
        });
    }

    @once
    getUsedCFs() {
        const questionTypesArray = Optional.ofNullable(this.questions)
            .orElse([])
            .map(question => question.get('kind'))
            .filter(_.identity);
        const customFields = questionTypesArray.filter(questionType => questionType.includes("cf"));

        return _.map(customFields, cf => cf.split("cf")[1]);
    }

    async setupCustomFields() {

        const idsOfCustomFields = this.getUsedCFs();
        const subscriptionIds = _.uniq(_.map(this.serviceCollection.models, model => model.get("subscriptionId")));
        if (!subscriptionIds.length || !idsOfCustomFields.length) return;

        const dataToPost = {
            ids: idsOfCustomFields,
            subscriptionIds
        };
        try {
            const response = await $.ajaxDefaultQ({
                url: '/CampaignCloud/CustomFields/getValues',
                data: dataToPost,
                type: 'POST'
            });
            if (response) {
                _.each(subscriptionIds, (subscriptionId) =>
                    this.serviceCollection.models.find(model => model.get("subscriptionId") === subscriptionId)
                        .set("customFieldsMap", response[subscriptionId]));
            }
        } catch (e) {
            console.log(e);
        }
    }

    async syncHandler() {
        await this.setupCustomFields();
        await this.loadContent();
    }

    loadContent() {
        this.setTemplateValues();

        this.$('[data-i18n]').i18n();
        if (this.paginationReport) {
            this.paginationReport.remove();
        }
        // Render collection the 1st time
        this.paginationReport = new PaginatedView({collection: this.serviceCollection});

        this.paginationReport.render();
        // Replace view's pagination
        $('#pagination-report').html(this.paginationReport.$el);

        //bind events that show/hide all answers
        if (this.serviceType === "Survey") {
            $(".viewAll").unbind("click").on("click", this.viewAllAnswers);
            $(".hideViewAllAnswers").unbind("click").on("click", this.hideViewAllAnswers);
        }
    }

    setTemplateValues() {
        var tempTemplate;
        const {serviceCollection, serviceType, description} = this;
        if (this.serviceType === "Voucher") {

            const dnModel = serviceCollection.displayName;
            const nameIdentifier = [dnModel.firstName, dnModel.lastName].filter(_.identity).filter(n => n.trim() !== "").join(" ");
            var displayName = nameIdentifier ? nameIdentifier : dnModel.username;

            tempTemplate = this.template({
                models: serviceCollection.models,
                countOfUniqueSubscriptions: serviceCollection.countContacts,
                countOfTotalRedemptions: serviceCollection.count,
                countContactsRedeemed: serviceCollection.countContactsRedeemed,
                serviceType,
                description,
                displayName
            }); //current User: to be used as a redeemer, in case there is not one.

            $("#voucherSentTo").html(serviceCollection.countContacts);
            $("#voucherRedeemed").html(serviceCollection.count);
            $("#voucherRedeemedTimesText").html(i18n.t("voucher.timeredeemed", {count: serviceCollection.count}));

        } else {
            if (this.serviceType === "Survey") {
                const mappedModels = serviceCollection.map(model => {
                    const newModel = model.clone();
                    const correspondingAnswer = serviceCollection.answers
                        .find(a => a.surveyCode === newModel.get("surveyCode"));

                    if (correspondingAnswer) {
                        correspondingAnswer.surveyAnswerList = correspondingAnswer.surveyAnswerList
                            .map((a, i) => Object.assign({
                                title: this.questions[i].get("title"),
                                textQuestion: this.questions[i].get("textQuestion")
                            }, a));
                        newModel.set("answers", correspondingAnswer);
                    } else {
                        console.info("No answers found");
                    }
                    return newModel;
                });
                serviceCollection.set(mappedModels);
            }

            var map = {
                models: serviceCollection.models,
                questions: this.questions,
                serviceType
            };
            if (serviceType === "Survey") {
                map["countOfUniqueSubscriptions"] = serviceCollection.countContacts;
                map["countOfTotalCompletions"] = serviceCollection.count;
                map["countContactsCompleted"] = serviceCollection.countContactsCompleted;
            } else if (serviceType === "PayPalPayment") {
                map["buyers"] = serviceCollection.buyers ? serviceCollection.buyers : 0;
            } else {
                // Optin
                map["recipients"] = serviceCollection.recipients;
            }
            tempTemplate = this.template(map);
            if (serviceType === "Survey") {
                $("#surveySentTo").html(serviceCollection.countContacts);
                $("#surveysFilledIn").html(serviceCollection.count);
                $("#surveysFilledIn2").html(serviceCollection.count);
                $("#surveysFilledInTimesText").html(i18n.t("survey.times", {count: serviceCollection.count}));
            } else if (serviceType === "Optin") {
                $("#optinSentTo").html(serviceCollection.visits);
                $("#optinConversionRate").html(serviceCollection.visits > 0 ?
                    this.getDoubleForLessThanTen(100 * serviceCollection.recipients / serviceCollection.visits) + "%" : "-"
                );
                $("#optinAcquisitions").html(serviceCollection.recipients);
                $("#optinAcquisitions2").html(serviceCollection.recipients);
                $("#optinAcquisitionsTimesText").html(i18n.t("survey.times", {count: serviceCollection.recipients}));
            } else if (serviceType === "PayPalPayment") {
                $("#Acquisitions").html(serviceCollection.recipients);
                $("#acquistionsText").html(i18n.t("optin.acquisition", {count: serviceCollection.recipients}));
                $("#optinBuyers").html(serviceCollection.buyers ? serviceCollection.buyers : 0);
                $("#buyersText").html(i18n.t("optin.buyer", {count: serviceCollection.buyers}));
                $("#optinSentTo").html(serviceCollection.visits);
                $("#visitsText").html(i18n.t("optin.visits", {count: serviceCollection.visits}));
                var payPalComponent = _.filter(this.questions, function (question) {
                    return question.get("type") === "PayPalButton";
                });
                $("#amount").html(((serviceCollection.buyers ? serviceCollection.buyers : 0) * payPalComponent[0].get("price")) + "&#8364;");
                $("#optinConversionRate").html(serviceCollection.visits > 0 ?
                    this.getDoubleForLessThanTen(100 * (serviceCollection.buyers ? serviceCollection.buyers : 0) / serviceCollection.visits) + "%" : "-"
                );

                $("#quantityReport").text(payPalComponent[0].get("quantity"));
                $("#itemsLeft").text(serviceCollection.itemsLeft);
            } else { // "InstantWin" and "Quiz"
                $("#instantWinConversionRate").text(serviceCollection.visits > 0 ?
                    this.getDoubleForLessThanTen(100 * serviceCollection.recipients / serviceCollection.visits) + "%" : "-");
                $("#instantWinConversionRateText").text(i18n.t("dashboard.conversionrate"));
                if (this.isSweepstakes) {
                    $("#instantWinWinners2").text(serviceCollection.participants); //counter in the "participants" tab
                } else {
                    $("#instantWinWinners2").text(serviceCollection.winners); //counter in the "winners" tab
                }
                $("#instantWinParticipants").text(serviceCollection.participants);
                $("#instantWinParticipantsText").text(i18n.t("instantWin.participants", {count: serviceCollection.participants}));
                $("#instantWinVisits").text(serviceCollection.visits);
                $("#instantWinVisitsText").text(i18n.t("instantWin.views", {count: serviceCollection.visits}));
            }
        }
        $(".service_report_content").html(tempTemplate);
        if (this.paginationReport) {
            this.paginationReport.render();
            // Replace view's pagination
            $('#pagination-report').html(this.paginationReport.$el);
        }
        //bind events that show/hide all answers
        if (serviceType === "Survey") {
            $(".viewAll").unbind("click").on("click", this.viewAllAnswers);
            $(".hideViewAllAnswers").unbind("click").on("click", this.hideViewAllAnswers);
        }
    }

    getDoubleForLessThanTen(numb) {
        let n = parseInt(numb).toFixed(2);
        if (n.endsWith(".00")) {
            return n.substr(0, n.length - 3);
        } else {
            return n;
        }
    }

    viewAllAnswers(event) {
        var index = $(event.currentTarget).attr("data-index");
        $(`#allAnswers${index}`).fadeIn();
    }

    hideViewAllAnswers(event) {
        $(event.currentTarget).parent().parent().parent().fadeOut();
    }
}

// Returning instantiated views can be quite useful for having "state"
export default VoucherReportContentsView;
